import { render, staticRenderFns } from "./GenericElement.vue?vue&type=template&id=31f358d4"
import script from "./GenericElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenericElement.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports